import styled from "styled-components/macro";
import React from "react";
import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import PhotoBanner from "../components/DormPhotoBanner/PhotoBanner";
import NewAmenities from "../components/NewAmenities";
import AtAGlance from "../components/AtAGlance";
import Maps from "../components/Maps";
import ProCon from "../components/ProCon";
import FloorPlan from "../components/FloorPlan";
import SpectrumSidebar from "../components/SpectrumSidebar";
import ScrollToTop from "../components/ScrollToTop";
import { theme } from "../util/GlobalStyles";
import DormQuickReview from "../components/DormQuickReview";
import AdManager from "../components/AdManager";
import Modal from "../components/Modal";

const Page = styled.div`
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.darkGray};
  padding: 2rem;
  margin: 1rem 2rem 0rem 2rem; // changed top to 1rem from 3.25rem

  @media only screen and (max-width: 767px) {
    padding: 0rem;
		overflow: hidden;
    margin: 3.25rem 0rem 0rem 0rem;

    li {
      margin: 0.5rem 0rem;
    }

    ul {
      margin: 0.5rem 0rem;
      line-height: 1.3rem;
    }
	}
`

const DormHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0 0.5rem 0;

  @media only screen and (max-width: 767px) {
		padding: 1rem 0 0 0;
    margin: 0;
	}
`

const DormName = styled.h1`
  font-family: 'Georgia', sans-serif;
  font-style: regular;
  font-weight: 42;
  display: flex;
  color: #404040;
  align-self: center;
  text-align: center;

  @media only screen and (max-width: 767px) {
    font-style: normal;
		font-weight: normal;
    font-size: 40px;
	}
`;

const UnderlineWrapper = styled.div`
  width: 20%;
  display: flex;
  flex-direction: row;
  align-self: center;
  margin-top: -.5rem;

  @media only screen and (max-width: 767px) {
		width: 60%;
	}
`

const Underline = styled.hr`
  width: 45%;
  border: .01rem solid #404040;
  align-self: center;
`

const Dot = styled.span`
  height: 6px;
  width: 6px;
  background-color: #404040;
  border-radius: 50%;
  align-self: center;
  margin: .5rem;


  @media only screen and (max-width: 767px) {
		margin: .8rem;
	}
`

const DormImage = styled.div`
  display: flex;
  align-self: center;
  width: 90vw;
  height: 80vh;
  
  @media only screen and (max-width: 767px) {
		width: 100vw;
    height: 40vh;
	}
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center bottom;
`;

const Info = styled.div`
  display: flex;
  flex-direction: row;
`

const ColumnLeft = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 1rem;
  width: 65%;

  @media only screen and (max-width: 767px) {
    width: 100%;
    padding: 1rem;
  }
`
const ColumnRight = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  width: 35%;

  @media only screen and (max-width: 767px) {
    display: none;
  }
`
const StickyContainer = styled.div`
  position: sticky;
  top: ${props => props.buffer};

  @media only screen and (max-width: 768px) {
    display: none;
	}
`
const Sticky = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 1rem;
  margin-bottom: 2rem;
`

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1.5rem;
  margin-bottom: 0;
  padding: 2rem 0;
  border-bottom: 1px solid ${props => props.theme.lightGray};

  @media only screen and (max-width: 767px) {
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    line-height: 1rem;
    padding: 0 0 1.5rem 0;
    margin: 1rem 2rem 1rem 2rem;
    background-color: light-blue;
	}
`

const SectionTitle = styled.h2`
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 2rem;
  color: #707070;

  @media only screen and (max-width: 767px) {
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    margin-bottom: 1rem;
	}
`;

const StickyTitle = styled.h3`
  font-family: Raleway;
  font-weight: 500;
  color: #707070;
  display:flex;
`
const MarginWrapper = styled.div`
  margin-left: 1rem;

  @media only screen and (max-width: 767px) {
    margin: 0;
    font-size: 1rem;
    line-height: 1.3rem;
    font-weight: 400;
    font-style: normal;
	}
`;

const Mobile = styled.div`
  @media only screen and (min-width: 767px) {
    display: none;
  }
`;

const Desktop = styled.div`
  @media only screen and (max-width: 767px) {
    display: flex;
  }
`;

const ModalButton = styled.button`
  border: none;
  background: none;

  &:focus {
    outline: none;
  }
`;

let relatedDorms = [
  {
    DORM: "McBain Hall",
    image: "https://housing.columbia.edu/files/housing/McBain.jpg",
  },
  {
    DORM: "Furnald Hall",
    image: "https://housing.columbia.edu/files/housing/Furnald.jpg",
  },
];

const Dorm = ({ }) => {
  const { dorm } = useParams();
  const [dormInfo, setDormInfo] = useState({});
  const [amenities, setAmenities] = useState({});
  const [reviews, setReviews] = useState([]);
  const [dorm_photos, setDormPhotos] = useState([]);
  const [relatedArticles, setrelatedArticles] = useState([]);
  const [floorPlans, setFloorPlans] = useState([]);
  const [floorNames, setFloorNames] = useState([]);
  const [floorOffset, setFloorOffset] = useState(null);
  const [relatedDorms, setRelatedDorms] = useState([]);
  const [fullDescription, setFullDescription] = useState("");
  const [roomtype, setRoomType] = useState("");
  const [classMakeupDefault, setClassMakeupDefault] = useState("");
  const [dormStyle, setDormStyle] = useState("");
  const [mainImage, setMainImage] = useState("");
  const [quickReview, setQuickReview] = useState({});
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [isMobile, setIsMobile] = useState(false);

  const [classMakeupDetail, setClassMakeupDetail] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const updateDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
    setIsMobile(window.innerWidth <= 768);
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    const dormName = dorm.replaceAll("-", " ");
    fetchDormInfo(dormName);
    //fetchReviews(dormName);
    //fetchRelatedDorms(dormName);
    setAllDormInfo(dormName);
    window.addEventListener("resize", updateDimensions);
  }, []);

  const fetchDormInfo = async (dormName) => {
    fetch(`/api/getDormInfo/${dormName}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then(res => res.json())
      .then(dormInfo => {
        dormInfo.PROS = dormInfo.PROS.substring(0, dormInfo.PROS.length - 1).split('#');
        dormInfo.CONS = dormInfo.CONS.substring(0, dormInfo.CONS.length - 1).split('#');
        let tempLot = dormInfo.LOTTERY_NUMS.split(',');
        let i = 0;
        for (i = 0; i < tempLot.length; i++) {
          tempLot[i] = tempLot[i].split(':');
        }
        dormInfo.LOTTERY_NUMS = tempLot;
        document.title = dormInfo.DORM;
        setDormInfo(dormInfo);

        setFullDescription(dormInfo.DESCRIPTION.substring(0, dormInfo.DESCRIPTION.length - 1));
        setClassMakeupDefault(dormInfo.CLASS_MAKEUP.split(",").map((el, i) => el.charAt(0).toUpperCase() + el.slice(1)).join(", "));
        if (dormInfo.BUILDING_TYPE_ === 2) setDormStyle("Apartment-Style");
        else if (dormInfo.BUILDING_TYPE_ === 1) setDormStyle("Suite-Style");
        else setDormStyle("Corridor-Style");
        setRoomTypeString(dormInfo);
      }).catch(error => {
        console.log(error);
      });
  }

  const setAllDormInfo = (dormName) => {
    fetchAllDormInfo(dormName)
      .then(([amenities, photos, relArticles, floorPlans, classMakeup]) => {
        setAmenities(amenities);
        handlePhotos(photos);
        handleRelArticles(relArticles);
        handleFloorPlans(floorPlans);
        setClassMakeupDetail(classMakeup);
      }).catch(error => {
        console.log(error);
      });

    fetchQuickReview(dormName)
      .then(quickReview => {
        console.log(quickReview);
        if (quickReview.dorm) {
          setQuickReview({ cleanliness: quickReview.clean, noise: quickReview.noise, community: quickReview.community, party: quickReview.party, amenities: quickReview.amenities })
        } else {
          setQuickReview(null)
        }
      }).catch(error => {
        console.log(error.message);
      });
  }

  async function fetchAllDormInfo(dormName) {
    const [amenitiesRes, photosRes, relArticlesRes, floorPlansRes, classMakeupRes] = await Promise.all([
      fetch(`/api/getAmenities/${dormName}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }),
      fetch(`/api/getDormPhotos/${dormName}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }),
      fetch(`/api/getRelatedArticles/${dormName}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }),
      fetch(`/api/getFloorPlans/${dormName}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }),
      fetch(`/api/getClassMakeupInfo/${dormName}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }),
    ]);

    const amenities = await amenitiesRes.json();
    const photos = await photosRes.json();

    // debug image issue
    // console.log("Photos right after API call", photos);

    const relArticles = await relArticlesRes.json();
    const floorPlans = await floorPlansRes.json();
    console.log("classMakeupRes ok", classMakeupRes.ok)
    const classMakeup = await classMakeupRes.json();
    return [amenities, photos, relArticles, floorPlans, classMakeup];
  }

  async function fetchQuickReview(dormName) {
    const quickReviewRes = await fetch(`/api/getQuickReview/${dormName}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!quickReviewRes.ok) {
      const message = `An error has occured: ${quickReviewRes.status}`;
      throw new Error(message);
    }

    const quickReview = await quickReviewRes.text();
    const quickReviewJSON = quickReview ? JSON.parse(quickReview) : {}
    return quickReviewJSON;
  }

  const handlePhotos = (dormPhotos) => {
    // console.log("dormPhotos", dormPhotos);
    setMainImage(dormPhotos[0]["IMAGE_LINK"]);

    // var photoarr = [];
    // for (var i = 0; i < dormPhotos.length; i++) {
    //   photoarr.push(dormPhotos[i]["IMAGE_LINK"]);
    // }

    const photoarr = dormPhotos.map(photo => photo["IMAGE_LINK"]);

    // console.log("photoarr", photoarr)
    setDormPhotos(photoarr);
  }

  const handleRelArticles = (relatedArticles) => {
    var relArticles = [];
    for (var i = 0; i < relatedArticles.length; i++) {
      relArticles.push({
        title: relatedArticles[i].TITLE,
        img_src: relatedArticles[i].IMAGE_URL,
        author: relatedArticles[i].AUTHOR,
        date: relatedArticles[i].DATE,
        url: relatedArticles[i].RELATED
      });
    }
    console.log(relArticles);
    setrelatedArticles(relArticles);
  }

  const handleFloorPlans = (floorPlans) => {
    let floorPlan = floorPlans;
    let floor_state = [];
    let floor_name = [];
    let keys = Object.keys(floorPlan);
    let floor_offset = 1;
    let stop_offset = 0;

    for (var i = 0; i < keys.length; i++) {
      var floorNum = keys[i];
      if (keys[i] == "DORM") {
        continue;
      } else if (floorPlan[floorNum] === "" || floorPlan[floorNum] === null) {
        if (stop_offset === 0) {
          floor_offset++;
          console.log(floor_offset);
        }
      } else {
        stop_offset = 1;
        console.log("TBAPPENDED:", floorPlan[floorNum]);
        floor_state[floorNum] = 'https://shaft-dorm-floorplans.s3.amazonaws.com/' + floorPlan[floorNum].replace("Carlton", "Carlton Arms").replace("Lower Townhouses", "LT").replace("Middle Townhouses ", "MT").replace("Upper Townhouses ", "UT").replace(/ /g, '+');
        floor_name[floorNum] = floorPlan[floorNum].slice(0, -4).replace("_", " ");
      }
    }

    setFloorPlans(floor_state);
    setFloorNames(floor_name);
    setFloorOffset(floor_offset);
    console.log("floor_state: ")
    console.log(floor_state)
    console.log(floor_offset)
  }

  function fetchReviews(dormName) {
    fetch(`/api/getReviews/${dormName}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then(res => res.json())
      .then(reviewsInfo => {
        //console.log(reviewsInfo);
        setReviews({ reviews: reviewsInfo.reviews, avg_rating: reviewsInfo.avg_rating, reccomend: reviewsInfo.reccomended, ranking: reviewsInfo.ranking });
      }).catch(error => {
        console.log(error);
      });
  }

  function fetchRelatedDorms(dormName) {
    fetch(`/api/getRelatedDorms/${dormName}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res => res.json()))
      .then(relatedDorms => {
        let relDorms = [];
        for (let i = 0; i < relatedDorms.length; i++) {
          relDorms.push({
            "DORM": relatedDorms[i].RELATED,
            "image": relatedDorms[i].IMAGE
          }
          );
        }
        setRelatedDorms(relDorms);
      }).catch(error => {
        console.log(error);
      });
  }

  const setRoomTypeString = (dormInfo) => {
    var roomtype = "";

    if (dormInfo.WALKTHROUGH) {
      roomtype += "Doubles and walkthrough doubles";
    } else {
      if (dormInfo.SINGLE_ && dormInfo.DOUBLE_ && dormInfo.TRIPLE_) {
        roomtype += " Singles, doubles, and triples";
      } else if (dormInfo.SINGLE_ && dormInfo.DOUBLE_) {
        roomtype += " Singles and doubles";
      } else {
        if (dormInfo.SINGLE_) roomtype += "Singles";
        if (dormInfo.DOUBLE_) roomtype += "Doubles";
        if (dormInfo.TRIPLE_) roomtype += " and triples";
      }
    }

    setRoomType(roomtype);
  }

  const headerButtons = {
    fontSize: 15, textAlign: "center",
    background: theme.columbiaBlue, color: "white",
    borderRadius: 7, paddingTop: 10, paddingBottom: 10, paddingLeft: 5, paddingRight: 5,
    justifyContent: 'center', alignItems: 'center', minWidth: '160px', border: 'none',
    marginTop: '0.5rem'
  }

  return (
    <ScrollToTop>
      <Page>
      <AdManager width={728} height={90} path="shaftleader"/>
        <DormHeader>
          <DormName> {(dormInfo.DORM === "600 W 113th") ? "600 W 113th (Nuss)" : dormInfo.DORM}</DormName>
          <UnderlineWrapper>
            <Underline></Underline>
            <Dot></Dot>
            <Underline></Underline>
          </UnderlineWrapper>
        </DormHeader>
        {/* <Desktop>
          {(dorm_photos.length === 0) ? <div></div> : <PhotoBanner bannerImages={dorm_photos} />}
        </Desktop> */}
        <Info>
          <ColumnLeft>
            <Desktop>
              <ModalButton onClick={(e) => {
                if (!e.target.closest('.control-arrow')) {
                  setModalOpen(true)
                }
              }}>
                <PhotoBanner bannerImages={dorm_photos} isModal={false} />
              </ModalButton>
              <Modal 
                open={modalOpen}
                dorm_photos={dorm_photos}
                onClose={() => setModalOpen(false)}
              ></Modal>
            </Desktop>
            <InfoSection style={{ borderTop: "1px solid #e0e0e0" }}>
              <SectionTitle>{dormInfo.SHORT_DESCRIPTION}</SectionTitle>
              <MarginWrapper>{fullDescription}</MarginWrapper>
            </InfoSection>
            <Mobile>
              <InfoSection>
                <AtAGlance address={dormInfo.ADDRESS} classMakeup={classMakeupDefault} roomtype={roomtype} />
              </InfoSection>
              <InfoSection>
                <SectionTitle>Quick review</SectionTitle>
                {quickReview === null ? null :
                  <DormQuickReview QuickReview={quickReview}></DormQuickReview>}
                <a href="https://forms.gle/VaYeYx2PQf29MLos6" style={headerButtons}>Submit your ratings</a>
              </InfoSection>
            </Mobile>
            <InfoSection>
              <SectionTitle>Amenities</SectionTitle>
              <MarginWrapper>
                <NewAmenities amenities={amenities} />
              </MarginWrapper>
            </InfoSection>
            {dormInfo.DORM === "Carman Hall" ? null :
              <InfoSection>
                <ProCon
                  pros={dormInfo.PROS}
                  cons={dormInfo.CONS}
                />
              </InfoSection>}
            {floorOffset ? <InfoSection>
              <SectionTitle>Floor Plans</SectionTitle>
              <MarginWrapper>
                <FloorPlan
                  floorOffset={floorOffset}
                  planArray={floorPlans}
                  planNames={floorNames}
                />
              </MarginWrapper>
            </InfoSection> : null}
            <Mobile>
              {(dormInfo.LATITUDE && dormInfo.LONGITUDE) ?
                <InfoSection>
                  <SectionTitle>Location</SectionTitle>
                  <MarginWrapper>
                    <Maps
                      latitudes={[dormInfo.LATITUDE]}
                      longitudes={[dormInfo.LONGITUDE]}
                      popupInfo={[dormInfo.DORM]}
                      popupId={[dormInfo.DORM]}
                      centerLatitude={dormInfo.LATITUDE}
                      centerLongitude={dormInfo.LONGITUDE}
                      zoom={16}
                      width={"100%"}
                      height={"300px"}
                    /></MarginWrapper>
                </InfoSection> : null}
              </Mobile>

            {/* <InfoSection>
              <SectionTitle>Photo Gallery</SectionTitle>
            </InfoSection> */}

            {(relatedArticles.length == 0) ? null :
              <InfoSection>
                <SectionTitle>Spectrum on Housing</SectionTitle>
                <SpectrumSidebar spectrumSidebarData={relatedArticles} />
              </InfoSection>
            }
          </ColumnLeft>
          <ColumnRight>
            <StickyContainer buffer="5rem">
              {(dormInfo.LATITUDE && dormInfo.LONGITUDE) ?
                <MarginWrapper>
                  <Maps
                    latitudes={[dormInfo.LATITUDE]}
                    longitudes={[dormInfo.LONGITUDE]}
                    popupInfo={[dormInfo.DORM]}
                    popupId={[dormInfo.DORM]}
                    centerLatitude={dormInfo.LATITUDE}
                    centerLongitude={dormInfo.LONGITUDE}
                    zoom={16}
                    width={"100%"}
                    height={"480px"}
                  /></MarginWrapper>: null}
              <Sticky>
                <AtAGlance address={dormInfo.ADDRESS} classMakeupDefault={classMakeupDefault} classMakeupDetail={classMakeupDetail} roomtype={roomtype} />
              </Sticky>
              <Sticky>
                <StickyTitle>Quick Review</StickyTitle>
                {quickReview === null ? null :
                  <DormQuickReview QuickReview={quickReview}></DormQuickReview>}
                <a href="https://forms.gle/VaYeYx2PQf29MLos6" style={headerButtons}>Submit your ratings</a>
              </Sticky>
            </StickyContainer>
          </ColumnRight>
        </Info>
      </Page>
    </ScrollToTop>
  );
}

export default Dorm;
